import { RefreshCw } from 'lucide-react';
import { Button } from '@/shared/ui/Button';
import { useCanSyncIntegrations } from '@/shared/hooks/useCanSyncIntegrations';

interface SyncNowButtonProps {
  syncing: boolean;
  onSync: () => void;
}

/** "Sync now" for the ads views. Shown only to roles the backend lets run a sync. */
export function SyncNowButton({ syncing, onSync }: SyncNowButtonProps) {
  if (!useCanSyncIntegrations()) return null;
  return (
    <Button
      variant="secondary"
      size="sm"
      leftIcon={<RefreshCw size={14} />}
      isLoading={syncing}
      onClick={onSync}
    >
      Sync now
    </Button>
  );
}
